<div id="policy" [style.background-color]="getBackgroundColor(valid)" [style.color]="getColor(valid)" [class.loader-hidden]="!show">
  <span>
    <span>Password must contain:</span>
    <ul>
      <li>
        <span class="inline">
          <mat-icon [style.color]="getColor(length)" class="m-r-5">{{length ? 'check_circle' : 'highlight_off'}}</mat-icon>
          {{PasswordPolicies.lengthRequirement}}
        </span>
      </li>
      <li id="capital">
        <span class="inline">
          <mat-icon [style.color]="getColor(capital)" class="m-r-5">{{capital ? 'check_circle' : 'highlight_off'}}</mat-icon>
          {{PasswordPolicies.upperCaseRequirement}}
        </span>
      </li>
      <li id="small">
        <span class="inline">
          <mat-icon [style.color]="getColor(small)" class="m-r-5">{{small ? 'check_circle' : 'highlight_off'}}</mat-icon>
          {{PasswordPolicies.lowerCaseRequirement}}
        </span>
      </li>
      <li id="number">
        <span class="inline">
          <mat-icon [style.color]="getColor(number)" class="m-r-5">{{number ? 'check_circle' : 'highlight_off'}}</mat-icon>
          {{PasswordPolicies.numericRequirement}}
        </span>
      </li>
      <li id="symbol">
        <span class="inline">
          <mat-icon [style.color]="getColor(symbol)" class="m-r-5">{{symbol ? 'check_circle' : 'highlight_off'}}</mat-icon>
          {{PasswordPolicies.specialCharRequirement}}<br>  {{PasswordPolicies.characterList}}
        </span>
      </li>
    </ul>
  </span>
</div>
